var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDjango(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2BA977;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.5,0.5h8.1v37.2c-4.2,0.8-7.2,1.1-10.5,1.1c-9.9,0-15.1-4.4-15.1-12.9c0-8.2,5.5-13.5,13.9-13.5 c1.3,0,2.3,0.1,3.5,0.4V0.5z M23.8,19.4c-0.9-0.3-1.7-0.4-2.7-0.4c-4.1,0-6.5,2.5-6.5,6.9c0,4.3,2.3,6.6,6.4,6.6 c0.9,0,1.6-0.1,2.8-0.2V19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.9,13.3v18.6c0,6.4-0.5,9.5-1.9,12.1c-1.3,2.6-3,4.2-6.6,5.9l-7.5-3.5c3.6-1.7,5.3-3.1,6.4-5.4 c1.2-2.3,1.5-4.9,1.5-11.9V13.3H44.9L44.9,13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36,0.5h8.1v8.2H36V0.5L36,0.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDjango);
export default __webpack_public_path__ + "static/media/django.ff9b8a4516b44aa76807cabb16d2bfda.svg";
export { ForwardRef as ReactComponent };